<template>
    <div
        class="flex items-center gap-3"
        data-spec-class="field-switch-loading"
    >
        <div
            class="flex h-6 w-6 shrink-0 items-center justify-center"
            aria-hidden="true"
        >
            <BaseSpinner
                class="pointer-events-none mb-0.5 shrink-0"
                :is-active="!!isLoading"
            />
        </div>

        <BaseFieldSwitch
            :model-value="modelValue"
            :is-disabled="isDisabled || isLoading"
            :name="name"
            v-bind="$attrs"
            @click="$emit('click')"
            @update:model-value="$emit('update:modelValue', $event)"
        />
    </div>
</template>

<script setup lang="ts">
import BaseFieldSwitch from './BaseFieldSwitch.vue';
import BaseSpinner from './BaseSpinner.vue';

defineProps<{
    modelValue: boolean;
    name: string;
    isDisabled?: boolean;
    isLoading?: boolean;
}>();

defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'click'): void;
}>();
</script>
